import React from 'react';
import { Activity, Star, ShieldCheck, ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-gradient-to-b from-volley-soft to-volley-paper overflow-hidden pt-5 pb-10 sm:pt-10 sm:pb-16 px-4 sm:px-6 lg:px-8" data-id="element-118">
      {/* Subtle decorative blobs */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-volley-teal/15 rounded-full blur-3xl pointer-events-none" data-id="element-119"></div>
      <div className="absolute -bottom-40 -left-40 w-[600px] h-[600px] bg-volley-orange/10 rounded-full blur-3xl pointer-events-none" data-id="element-120"></div>

      <div className="relative max-w-3xl mx-auto flex flex-col items-center text-center z-10" data-id="element-121">
        <div className="flex items-center gap-2 mb-3 sm:mb-6" data-id="element-122">
          <Activity className="w-4 h-4 sm:w-5 sm:h-5 text-volley-teal" data-id="element-123" />
          <span className="font-display font-semibold text-volley-navy text-base sm:text-lg tracking-[0.25em] uppercase" data-id="element-124">
            VOLLEY PRONTO
          </span>
        </div>

        <div className="bg-white/80 backdrop-blur-md border border-volley-teal/20 text-volley-teal-dark font-medium text-[10px] sm:text-sm px-4 py-1.5 rounded-full mb-4 sm:mb-8 flex items-center gap-2 shadow-sm" data-id="element-125">
          <span data-id="element-126">✨</span> IL METODO DI ALLENAMENTO VALIDATO
        </div>

        <h1 className="font-display sm:text-5xl md:text-6xl font-medium text-volley-dark leading-[1.15] sm:leading-[1.05] mb-4 sm:mb-6 tracking-tight text-[28px]" data-id="element-127">
          Il Sistema di{' '}
          <span className="italic text-volley-orange" data-id="element-128">Pianificazione</span>{' '}
          Integrato per Allenatori di Pallavolo
        </h1>

        <p className="text-sm sm:text-lg text-volley-slate max-w-xl mb-6 sm:mb-10 leading-relaxed px-2 sm:px-0" data-id="element-129">
          Risparmia tempo, ritrova la tua serenità ed eleva il livello dei tuoi
          allenamenti — senza lo stress della pianificazione manuale.
        </p>

        <div className="mb-6 sm:mb-10 max-w-[280px] sm:max-w-lg mx-auto w-full relative" data-id="element-130">
          <div className="absolute inset-0 bg-volley-navy/5 rounded-2xl blur-xl transform translate-y-4" data-id="element-131"></div>
          <img src="https://cdn.magicpatterns.com/uploads/jjRs1JqwthzyTRBN5QdTiY/image_(8).webp" alt="Volley Pronto 6-in-1 Box Set" className="relative w-full rounded-2xl shadow-2xl border border-white/50" fetchPriority="high" decoding="async" width="800" height="800" data-id="element-132" />
        </div>

        <a href="#pricing-card" className="group relative inline-flex items-center justify-center gap-3 bg-gradient-to-r from-volley-orange to-volley-orange-dark text-white font-semibold text-sm sm:text-lg py-4 px-8 sm:px-12 rounded-full shadow-[0_10px_30px_rgba(238,122,35,0.35)] hover:shadow-[0_15px_40px_rgba(238,122,35,0.5)] hover:-translate-y-1 transition-all duration-300 w-full sm:w-auto" data-id="element-133">
          <span data-id="element-134">🚀 SÌ, VOGLIO IL MIO METODO ORA</span>
          <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-135" />
        </a>

        <div className="mt-6 flex flex-col items-center gap-2" data-id="element-136">
          <div className="flex items-center gap-2" data-id="element-137">
            <div className="flex text-volley-yellow" data-id="element-138">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4" fill="currentColor" data-id="element-139" />)}
            </div>
            <span className="text-volley-slate text-xs sm:text-sm font-medium" data-id="element-140">
              4.9/5 — Recensioni Professionali Verificate
            </span>
          </div>
          <div className="flex items-center gap-2 text-volley-slate text-xs sm:text-sm" data-id="element-141">
            <ShieldCheck className="w-4 h-4 text-volley-teal" data-id="element-142" />
            <span data-id="element-143">Garanzia 7 Giorni — Zero Rischi</span>
          </div>
        </div>
      </div>
    </section>;
}